import { render, staticRenderFns } from "./ResumoDaLinha.vue?vue&type=template&id=745614c4&scoped=true"
import script from "./ResumoDaLinha.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumoDaLinha.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResumoDaLinha.vue?vue&type=style&index=0&id=745614c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745614c4",
  null
  
)

export default component.exports